import {useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {toggleModal} from 'store/parking-pass/parking-pass-actions';
import {CHANGE_VEHICLE} from 'store/parking-pass/parking-pass-reducer';
import {getParkingPass} from 'store/parking-pass/parking-pass-selectors';
import trackParkingPassClick from 'segment/events/parking-pass-click';
import ReservationUtils from 'utils/reservation-utils';
import dayjs from 'utils/dayjs-timezone';

const useVehicleChangeProps = () => {
    const dispatch = useDispatch();
    const {data: reservation} = useSelector(getParkingPass);
    const user = useSelector(state => state.user.data);

    const activeStatus = useMemo(() => {
        const currentTime = dayjs.utc(dayjs()).tz(reservation.timezone);

        if (currentTime < reservation.starts) {
            return ReservationUtils.ACTIVE_STATUS.NOT_STARTED;
        } else if (currentTime > reservation.ends) {
            return ReservationUtils.ACTIVE_STATUS.ENDED;
        }

        return ReservationUtils.ACTIVE_STATUS.ACTIVE;
    }, [reservation.starts, reservation.ends, reservation.timezone]);

    const trackClick = () => {
        trackParkingPassClick({
            reservation,
            user,
            clickTarget: 'Add/Change Vehicle',
            isReservationChange: true,
            activeStatus,
        });
    };

    const handleEditClick = () => {
        trackClick();

        dispatch(toggleModal({modal: CHANGE_VEHICLE}));
    };

    const buttonProps = {
        onClick: handleEditClick,
    };

    return buttonProps;
};

export default useVehicleChangeProps;
